const locale = {
    // Existing translations
    AWAITING_MAINTENANCE: 'Очакващи техническа поддръжка',
    BEGIN_MAINTENANCE: 'Започни поддръжка',
    ROOM_NUMBER: 'Стая номер',
    Repairing: 'В процес на поддръжка',
    Broken: 'Очаква поддръжка',
    
    // Notification translations
    MAINTENANCE_PROBLEM_TITLE: 'Нова заявка за поддръжка',
    MAINTENANCE_PROBLEM_BODY: 'Стая {{room}}: {{problem}} (Приоритет: {{priority}})',

    // Tech Support Dashboard translations
    TECH_SUPPORT_DASHBOARD: 'Табло за техническа поддръжка',
    
    // Stats Cards
    TOTAL_REQUESTS: 'Общо заявки',
    PENDING: 'Чакащи',
    IN_PROGRESS: 'В процес',
    COMPLETED: 'Завършени',
    COMPLETED_SINGLE: 'Завършена',
    LAST_24H: 'Последните 24ч',
    LAST_7_DAYS: 'Последните 7 дни',
    
    // Filters
    SEARCH: 'Търсене',
    STATUS: 'Статус',
    ALL_STATUSES: 'Всички статуси',
    
    // Table Headers
    ROOM: 'Стая',
    ITEM: 'Елемент',
    DESCRIPTION: 'Описание',
    START_TIME: 'Начало',
    END_TIME: 'Край',
    DURATION: 'Продължителност',
    ACTIONS: 'Действия',
    
    // Action Buttons
    VIEW: 'Преглед',
    START: 'Започни',
    FINISH: 'Завърши',
    REFRESH: 'Обнови',
    
    // Dialog
    MAINTENANCE_REQUEST_DETAILS: 'Детайли за заявката за поддръжка',
    REQUEST_INFORMATION: 'Информация за заявката',
    TIMELINE: 'Времева линия',
    CLOSE: 'Затвори',
    START_REQUEST: 'Започни заявката',
    FINISH_REQUEST: 'Завърши заявката',
    
    // Request Info Labels
    FLOOR: 'Етаж',
    CATEGORY: 'Категория',
    LAST_UPDATED: 'Последно обновено',
    ASSIGNED_TO: 'Назначено на',
    REPORTED_BY: 'Докладвано от',
    STARTED: 'Започнато',
    NOT_STARTED: 'Не е започнато',
    NO_DURATION: 'Няма продължителност',
    
    // Status Values
    REPORTED: 'Докладвано',
    ASSIGNED: 'Назначено',
    AWAITING_FIXING: 'Очаква поправка',
    CANCELLED: 'Отменено',
    
    // Error Messages
    FAILED_TO_FETCH_REQUESTS: 'Неуспешно зареждане на заявките за поддръжка',
    FAILED_TO_START_REQUEST: 'Неуспешно започване на заявката за поддръжка',
    FAILED_TO_FINISH_REQUEST: 'Неуспешно завършване на заявката за поддръжка',
    
    // Success Messages
    REQUEST_STARTED_SUCCESSFULLY: 'Заявката за поддръжка е започната успешно',
    REQUEST_COMPLETED_SUCCESSFULLY: 'Заявката за поддръжка е завършена успешно',
    
    // Create Request Form
    CREATE_MAINTENANCE_REQUEST: 'Създай заявка за поддръжка',
    SELECT_ROOM: 'Избери стая',
    SELECT_ROOM_HELP: 'Изберете стаята, където е проблемът с поддръжката',
    SELECT_ITEM: 'Избери елемент',
    SELECT_ITEM_HELP: 'Изберете елемента, който се нуждае от поддръжка',
    PRIORITY: 'Приоритет',
    PRIORITY_LOW: 'Нисък',
    PRIORITY_MEDIUM: 'Среден',
    PRIORITY_HIGH: 'Висок',
    PRIORITY_CRITICAL: 'Критичен',
    DESCRIPTION_HELP: 'Моля опишете подробно проблема с поддръжката',
    DESCRIPTION_PLACEHOLDER: 'Опишете проблема детайлно...',
    ITEM_INFORMATION: 'Информация за елемента',
    REQUIRED_FIELDS_MESSAGE: 'Моля попълнете всички задължителни полета',
    CREATE_REQUEST: 'Създай заявка',
    CREATING: 'Създава...',
    CANCEL: 'Отказ',
    
    // Categories
    CATEGORY_FURNITURE: 'Мебели',
    CATEGORY_ELECTRONICS: 'Електроника',
    CATEGORY_BATHROOM: 'Баня',
    CATEGORY_LIGHTING: 'Осветление',
    CATEGORY_OTHER: 'Друго',
    
    // Loading States
    LOADING: 'Зарежда...',
    SUBMITTING: 'Изпраща...',
    
    // Empty States
    NO_REQUESTS_FOUND: 'Няма намерени заявки за поддръжка',
    NO_DATA_AVAILABLE: 'Няма налични данни',
    
    // Additional error messages for form
    FAILED_TO_CREATE_REQUEST: 'Неуспешно създаване на заявка за поддръжка. Моля опитайте отново.',
    FAILED_TO_LOAD_ROOMS: 'Неуспешно зареждане на стаите',
    FAILED_TO_LOAD_ITEMS: 'Неуспешно зареждане на елементите за поддръжка'
};

export default locale;
